export const fetchLoginApiUrl = `home`;

export const fetchLoginDialogApiUrl = 'login-dialog';

export const fetchSignupDialogApiUrl = 'signup-dialog';
